import styled from 'styled-components';

export const PanelHeader = styled.div`
  .panelTitle {
    float: left;
    font-size: 0.9em;
    font-family: Helvetica;
    color: white;
  };

  height: 35px;
  padding: 5px;
  width: auto;
  background-color: #303030;
`;

export const TransController = styled.div`
  .TransController {
    float: left;
    font-size: 0.9em;
    font-family: Helvetica;
  };

  height: 65px;
  padding: 5px;
  width: auto;
`;

export const Wrapper = styled.div`
  height: 100%;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
`;

export const SideMenu = styled.div`
  min-height: 100vh;
  flex: 10%;
  width: 80px;
  background-color: #303030;
`;

export const Content = styled.div`
  max-width: 98%
  min-height: 100%
  flex: 80%;
`;



// WEBPACK FOOTER //
// ./src/utils/styled.js